import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/movieContent";

export default function FaqSection() {
  return (
    <section id="faq" className="scroll-mt-20 bg-background-200/50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问答"
          title="常见问答：把容易混淆的地方说清楚"
          description="关于这部影片，大家最常问的几个问题都在这里。答案尽量保持客观，涉及评分与渠道的部分，以平台实时信息为准。"
          icon="ri-question-answer-line"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {faqs.map((item) => (
            <article
              key={item.q}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <h3 className="flex items-start gap-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                <i className="ri-question-line text-primary-500 mt-0.5"></i>
                {item.q}
              </h3>
              <p className="mt-3 pl-7 text-sm text-foreground-700 leading-relaxed">{item.a}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}